import React from "react";
import Box from "../../primitives/Box/Box";
import { Body6RegularTypography } from "../../primitives/Typography/typographyVariants";
import type { PLPProductCardSaleTag } from "./PLPProductCard.types";
import {
  isPlpSaleTagTrendyShape,
  resolvePlpSaleTagStyle,
} from "./plpSaleTagStyle";

/**
 * TagsWeb — Shopping design system (Figma 3222:15127). Text only; right edge shape from dev spec.
 * - Style 1 (bestseller / default): diagonal cut on the right.
 * - Style 2 (trendy): fishtail notch on the right.
 */
const CLIP_SLANT = "polygon(0 0, calc(100% - 12px) 0, 100% 100%, 0 100%)";
const CLIP_FISHTAIL =
  "polygon(0 0, calc(100% - 11px) 0, 100% 50%, calc(100% - 11px) 100%, 0 100%)";

export const PlpSaleTagLabel: React.FC<{ saleTag: PLPProductCardSaleTag }> = ({
  saleTag,
}) => {
  const { bg, color } = resolvePlpSaleTagStyle(saleTag);
  const clip = isPlpSaleTagTrendyShape(saleTag) ? CLIP_FISHTAIL : CLIP_SLANT;

  return (
    <Box
      display="inline-flex"
      alignItems="center"
      pl="4px"
      pr="14px"
      pt="2px"
      pb="2px"
      backgroundColor={bg}
      width="fit-content"
      style={{
        clipPath: clip,
        WebkitClipPath: clip,
      }}
    >
      <Body6RegularTypography
        color={color}
        fontSize="10px"
        lineHeight="15px"
        letterSpacing="0.2px"
      >
        {saleTag.label}
      </Body6RegularTypography>
    </Box>
  );
};
